import {
  FETCH_AUTH_REQUEST,
  FETCH_AUTH_SUCCESS,
  FETCH_AUTH_FAILURE,
  LOGOUT_AUTH,
  FETCH_SHORT_PIN_REQUEST,
  FETCH_SHORT_PIN_SUCCESS,
  FETCH_SHORT_PIN_FAILURE,
  FETCH_AUTH_PIN_REQUEST,
  FETCH_AUTH_PIN_SUCCESS,
  FETCH_AUTH_PIN_FAILURE,
} from "./action-types";

import {
  FetchLoginRequest,
  FetchLoginSuccess,
  FetchLoginSuccessPayload,
  FetchLoginFailure,
  FetchLoginFailurePayload,
  FetchShortPinSuccess,
  FetchShortPinSuccessPayload,
  FetchShortPinFailure,
  FetchShortPinFailurePayload,
  FetchPinLoginRequest,
  FetchPinLoginSuccess,
  FetchPinLoginSuccessPayload,
  FetchPinLoginFailure,
  FetchPinLoginFailurePayload,
} from "./types";

export const fetchAuthRequest = (
  username: string,
  password: string
): FetchLoginRequest => ({
  type: FETCH_AUTH_REQUEST,
  payload: { username, password },
});

export const fetchLoginSuccess = (
  payload: FetchLoginSuccessPayload
): FetchLoginSuccess => ({
  type: FETCH_AUTH_SUCCESS,
  payload,
});

export const fetchLoginFailure = (
  payload: FetchLoginFailurePayload
): FetchLoginFailure => ({
  type: FETCH_AUTH_FAILURE,
  payload,
});

export const fetchShortPinRequest = (access_token: string, hours: string) => ({
  type: FETCH_SHORT_PIN_REQUEST,
  payload: { access_token, hours },
});

export const fetchShortPinSuccess = (
  payload: FetchShortPinSuccessPayload
): FetchShortPinSuccess => ({
  type: FETCH_SHORT_PIN_SUCCESS,
  payload,
});

export const fetchShortPinFailure = (
  payload: FetchShortPinFailurePayload
): FetchShortPinFailure => ({
  type: FETCH_SHORT_PIN_FAILURE,
  payload,
});

export const fetchAuthPinRequest = (
  pincode: string,
  short_pin_token: string
): FetchPinLoginRequest => ({
  type: FETCH_AUTH_PIN_REQUEST,
  payload: { pincode, short_pin_token },
});

export const fetchPinLoginSuccess = (
  payload: FetchPinLoginSuccessPayload
): FetchPinLoginSuccess => ({
  type: FETCH_AUTH_PIN_SUCCESS,
  payload,
});

export const fetchPinLoginFailure = (
  payload: FetchPinLoginFailurePayload
): FetchPinLoginFailure => ({
  type: FETCH_AUTH_PIN_FAILURE,
  payload,
});

export const logout = () => ({
  type: LOGOUT_AUTH,
});
